module.exports = __webpack_public_path__ + "img/ranking-1.a1ab7e37.svg";